import { useRef } from "react";

const UseStopWatch = (setTime) => {
  const interval = useRef(null);
  // let [interval, setInterval] = useState(null);

  const handleStart = (e) => {
    interval.current = setInterval(() => {
      setTime((time) => time + 1);
    }, 1000);
  };

  const handleStop = (e) => {
    clearInterval(interval.current);
    setTime(0);
  };

  // const handleReset = (e) => {
  //   clearInterval(interval);
  //   setTime(0);
  // };

  return [handleStart, handleStop];
};

export default UseStopWatch;
